import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

/**
 * Main layout for AI platform pages.
 * Navigation is handled by the global Sidebar (frontend/src/components/Sidebar.jsx).
 * This layout provides consistent content padding for all AI pages.
 * Individual pages should NOT add their own root-level padding.
 */
export const MainLayout: React.FC = () => {
  const location = useLocation();
  const isFullBleedRoute =
    location.pathname === '/ai/ml/models/new' ||
    /^\/ai\/ml\/models\/[^/]+\/edit$/.test(location.pathname);

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: isFullBleedRoute ? '100%' : undefined,
        width: '100%',
        p: isFullBleedRoute ? 0 : { xs: 1, sm: 1.5, md: 2 },
        overflow: isFullBleedRoute ? 'hidden' : undefined,
        overflowX: isFullBleedRoute ? undefined : 'clip',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default MainLayout;
